import { Card as AntdCard, CardProps as AntdCardProps } from "antd";
import React from "react";
import * as styles from "./Card.css";

export interface CardProps extends AntdCardProps {
  /** Whether to use a shadow style for the card */
  shadow?: boolean;
}
const Card = ({ shadow = false, ...props }: CardProps) => {
  return (
    <AntdCard className={shadow ? styles.cardShadow : undefined} {...props} />
  );
};
export default Card;

Card.Meta = AntdCard.Meta;
